import './index.scss';
import React from 'react';
import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material';


interface CustomPopupProps extends MuiDrawerProps {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
}

const CustomPopup: React.FC<CustomPopupProps> = ({ children, isOpen, onClose, ...otherProps }) => {
    return (
        <MuiDrawer
            anchor="bottom"
            open={isOpen}
            onClose={onClose}
            sx={{ borderRadius: '24px 24px 0 0' }}
            PaperProps={{style: {borderTopLeftRadius: '24px', borderTopRightRadius: '24px'}}}
            {...otherProps}
        >
            {children}
        </MuiDrawer>
    );
};

export default CustomPopup;